import { motion } from "framer-motion";

export default function StatCard({ title, value }) {
    return (
        <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-gradient-to-br from-white/10 to-white/5 
                       backdrop-blur-xl p-6 rounded-2xl shadow-xl 
                       border border-white/10"
        >
            <p className="text-gray-400">{title}</p>
            <h2 className="text-3xl font-bold mt-2">{value}</h2>
        </motion.div>
    );
}